/**
 * Toast notification store
 */

import { create } from 'zustand';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

export interface Toast {
  id: string;
  type: ToastType;
  title?: string;
  message?: string;
  duration?: number;
}

interface ToastState {
  toasts: Toast[];
  
  addToast: (toast: Omit<Toast, 'id'>) => void;
  removeToast: (id: string) => void;
  clearAll: () => void;
}

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  
  addToast: (toast) => {
    const id = Math.random().toString(36).substring(7);
    const duration = toast.duration || 5000;
    // Only set title when explicitly provided (avoids duplicating message when only message is passed)
    const title = toast.title !== undefined ? toast.title : undefined;
    
    set((state) => ({
      toasts: [...state.toasts, { ...toast, title, id }],
    }));
    
    // Auto-remove after duration
    if (duration > 0) {
      setTimeout(() => {
        set((state) => ({
          toasts: state.toasts.filter((t) => t.id !== id),
        }));
      }, duration);
    }
  },
  
  removeToast: (id) => set((state) => ({
    toasts: state.toasts.filter((t) => t.id !== id),
  })),
  
  clearAll: () => set({ toasts: [] }),
}));


